import posthog from 'posthog-js';
import { isDev } from '~~/services/common';

export default defineNuxtPlugin((nuxtApp) => {
    if (isDev()) {
        return;
    }
    const config = useRuntimeConfig();
    const key = config.public.posthogKey as string;
    if (!key) {
        return;
    }
    const posthogClient = posthog.init(key, { api_host: 'https://app.posthog.com', capture_pageleave: false });
    return {
        provide: {
            posthog: () => posthogClient,
        },
    };
});
